import { Anchor, DataView, Stack, useModals } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import {
  ContactEmails,
  ContactNumbers,
  ContactNumbersFormatted,
} from '~/constants/markets';
import { useClient } from '~/hooks/useClient';
import useHubspotChat from '~/hooks/useHubspotChat';
import withPostHogPageVisit from '~/components/hoc/withPostHogPageVisit';

const ContactUsModal = () => {
  const t = useTranslate();
  const modals = useModals();
  const { market } = useClient();
  const { openChat } = useHubspotChat();

  const handleOpenChat = () => {
    modals.closeAll();
    openChat();
  };

  return (
    <Stack>
      <DataView divider>
        <DataView.Section>
          <DataView.Label>{t('Phone')}</DataView.Label>
          <DataView.Value>
            <Anchor component="a" href={`tel:${ContactNumbers[market]}`}>
              {ContactNumbersFormatted[market]}
            </Anchor>
          </DataView.Value>
        </DataView.Section>
        <DataView.Section>
          <DataView.Label>{t('Email')}</DataView.Label>
          <DataView.Value>
            <Anchor component="a" href={`mailto:${ContactEmails[market]}`}>
              {ContactEmails[market]}
            </Anchor>
          </DataView.Value>
        </DataView.Section>
        <DataView.Section divider={false}>
          <DataView.Label>{t('ContactChat')}</DataView.Label>
          <DataView.Value>
            <Anchor onClick={handleOpenChat}>{t('Dashboard.Chat')}</Anchor>
          </DataView.Value>
        </DataView.Section>
      </DataView>
    </Stack>
  );
};

export default withPostHogPageVisit(ContactUsModal);
